import type { RouteRecordRaw } from 'vue-router';
import { FEATURE_FLAGS, ROLES } from '@AuthModule';

export default <RouteRecordRaw[]>[
  {
    path: 'kennel-manager',
    name: 'kennel-manager',
    component: () => import('./views/KennelManager.view.vue'),
    meta: {
      featureFlag: FEATURE_FLAGS.KENNEL_MANAGER,
      permissions: [ROLES.KENNEL_MANAGER],
    },
  },
];
